// extracted by mini-css-extract-plugin
module.exports = {"icon":"NavLink_icon__3FRmU","updated_icon":"NavLink_updated_icon__389Jc","label":"NavLink_label__Grn5g"};